import { PLAYABLE_CHARACTERS, type PlayableCharacterId } from '../render/AxieCharacter.ts';
import { CharacterPreview } from './CharacterPreview.tsx';

export function CharacterSelect({
  selectedId,
  onSelect,
  onBegin,
}: {
  selectedId: PlayableCharacterId;
  onSelect: (id: PlayableCharacterId) => void;
  onBegin: () => void;
}) {
  const selected = PLAYABLE_CHARACTERS.find((character) => character.id === selectedId) ?? PLAYABLE_CHARACTERS[0];
  const selectedIndex = PLAYABLE_CHARACTERS.findIndex((character) => character.id === selected.id);
  const selectOffset = (offset: number): void => {
    const nextIndex = (selectedIndex + offset + PLAYABLE_CHARACTERS.length) % PLAYABLE_CHARACTERS.length;
    const next = PLAYABLE_CHARACTERS[nextIndex];
    if (next) onSelect(next.id);
  };

  return (
    <main className="character-select" aria-labelledby="character-select-title">
      <div className="character-select-orbit" aria-hidden="true" />
      <section className="character-select-content">
        <p className="character-select-wordmark">Moonseed Portals</p>
        <h1 id="character-select-title">Choose your Axie</h1>
        <p className="character-select-intro">Your companion changes how the journey feels. Class Moonlight affinities are coming soon.</p>
        <div className="character-stage">
          <button type="button" className="character-cycle" aria-label="Previous character" onClick={() => selectOffset(-1)}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 5-7 7 7 7" /></svg>
          </button>
          <div className="character-feature">
            <CharacterPreview character={selected} />
            <p className="character-card-name">{selected.name}</p>
            <p className="character-card-class">{selected.axieClass} class</p>
            <p className="character-card-status">Moonlight affinity coming soon</p>
          </div>
          <button type="button" className="character-cycle" aria-label="Next character" onClick={() => selectOffset(1)}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 5 7 7-7 7" /></svg>
          </button>
        </div>
        <div className="character-select-footer">
          <p><strong>{selected.name}</strong> is ready for the Grove.</p>
          <button type="button" className="character-begin" onClick={onBegin}>Begin journey</button>
        </div>
      </section>
    </main>
  );
}
